module.exports = __webpack_public_path__ + "img/未启动.902ffb41.svg";